<template>
  <div class="card-container">
    <img v-if="data.facade" :src="data.facade_service" :alt="data.name" style="display: block;">
    <div v-else class="box-exposition">
      <img src="/assets/images/sala-de-exposicion.png" :alt="data.name" class="img-exposition">
    </div>
    <div class="card-bottom">
      <h3>{{ data.name }}</h3>
      <a :href="phone"
      target="_blank">Contactar</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: Object
    },
    computed: {
      phone() {
        return `https://wa.me/52${this.data.meta_leads_car_service_whatsapp_phone}?text=${this.data.car_service_whatsapp_message ?? ''}`
      }
    }
  }
</script>

<style scoped>
  .card-container {
    display: flex; 
    flex-direction: column; 
    background-color: #fff;
    width: 100%;
    height: 330px;
  }
  img {
    width: 100%;
    height: 140px;
  }
  .card-bottom {
    justify-content: center;
    flex: 1 0;
    padding: 30px 0;
    display: flex; 
    flex-direction: column;
    align-items: center;
    text-align: center;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  }
  
  .card-bottom > * {
    font-size: 18px;
    font-weight: 500;
  }

  .card-bottom > a {
    margin-top: 20px;
    background: #000;
    padding: 8px 16px;
    border-radius: 8px;
    color: #fff;
    text-transform: uppercase;
  }
  .box-exposition{
      display: flex;
      justify-content: center;
      height: 140px;
      align-items: center;
  }
  .img-exposition{
      display: flex;
      width: 100px;
      height: 100px;
  }
</style>